import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { TranslationPackage } from '@portal-core/translation-packages/models/translation-package.model';

@CollectionStateSelectors({
  stateType: TranslationPackagesState
})
@State<TranslationPackagesState>({
  name: TranslationPackagesState.source
})
@Service({ autoProvided: false })
export class TranslationPackagesState extends CollectionStateBase {
  static override source: string = 'TranslationPackages';
  getSource(): string {
    return TranslationPackagesState.source;
  }
}

@Service()
export class TranslationPackagesDataService extends CollectionDataServiceBase<TranslationPackage> {
  protected readonly stateType = TranslationPackagesState;
}
